const initParamData = {
  
}

export function paramData(
  state = initParamData,
  action
) {
  switch (action.type) {
    case "PARAM_FETCH_DATA_SUCCESS":
      return action.dataParam;
    default:
      return state;
  }
}